// Pathify
import { make } from 'vuex-pathify'

const state = {
  token: localStorage.getItem('token'),
  userInfo:JSON.parse(localStorage.getItem('userInfo'))
}

const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
